import React, { useMemo } from "react";
import initLayoutContainer from "opentok-layout-js";
import { VenueArchiveLayout } from "../../app/types";

const useStreamLayout = (
  streams: OT.Stream[],
  containerWidth: number,
  containerHeight: number,
) =>
  useMemo(() => {
    const payload: VenueArchiveLayout = {};
    if (streams.length > 0) {
      const layout = initLayoutContainer({
        containerWidth,
        containerHeight,
        fixedRatio: true,
        minBigPercentage: 0.6,
      }).getLayout(
        streams.map((stream) => ({
          height: stream.videoDimensions.height,
          width: stream.videoDimensions.width,
          big: stream.videoType === "screen",
        })),
      );

      for (let i = 0; i < streams.length; i++) {
        payload[streams[i].streamId] = layout.boxes[i];
      }
    }

    return payload;
  }, [containerHeight, containerWidth, streams]);

export default useStreamLayout;
